import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/helper/constants';
import { Observable, BehaviorSubject } from 'rxjs';
import { IMaps, IEvacuationAlertLevelResult } from 'src/app/models/map';
import { IFacility, IRiskCalculatorResult } from 'src/app/models/facility';
import { ICheckIn } from 'src/app/models/check-in';
import { ICheckOut } from 'src/app/models/check-out';
import { IComplaince, IComplainceSubmit } from 'src/app/models/assesment';
import { IComplainceResult } from 'src/app/shared/dialogues/assessmentdialog/assessmentdialog.component';
import { ICityRoot } from 'src/app/models/city';
import { IHistoryObject } from 'src/app/models/history';
import { ICheckInResponse } from 'src/app/models/check-in-response';
import { IPreApprovedSiteRequestResult } from 'src/app/feature/site-rediness-matrix/models/request';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  toolBarTitle = new BehaviorSubject<string>('');

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }

  getMaps(): Observable<IMaps> {
    return this.httpClient.get<IMaps>(Constants.GET_MAP_URL);
  }

  getFacilities(query: string): Observable<IFacility> {
    return this.httpClient.get<IFacility>(Constants.GET_FACILITIES + '?searchstring=' + query);
  }

  getLocationFacilities(country: string, city: string): Observable<IFacility> {
    return this.httpClient.get<IFacility>(Constants.GET_FACILITIES + '?searchstring=' + country + '&city=' + city);
  }

  getApprovedRequestForFacility(facilityId: number): Observable<IPreApprovedSiteRequestResult> {
    return this.httpClient.get(Constants.GET_APPROVED_REQUEST_FOR_FACILITY + facilityId);
  }

  postCheckInData = (checkInObj: ICheckIn[]): Observable<ICheckInResponse> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<ICheckInResponse>(Constants.POST_CHECK_IN, checkInObj, options);
  }

  postCheckOutData = (checkOutObj: ICheckOut[]): Observable<ICheckInResponse> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<ICheckInResponse>(Constants.POST_CHECK_OUT, checkOutObj, options);
  }

  postAssessmentDetails = (facilityId?: number): Observable<IComplaince[] | any> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    if (facilityId !== undefined) {
      return this.httpClient.post<IComplaince[]>(Constants.POST_COMPLAINCE, { facilityid: facilityId }, options);
    } else {
      return this.httpClient.post<IComplaince[]>(Constants.POST_COMPLAINCE, {}, options);
    }
  }

  postComputeStatusDetails = (object: IComplainceSubmit): Observable<IComplainceResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IComplainceResult>(Constants.POST_COMPUTE_STATUS, object, options);
  }

  getCities(query: string): Observable<ICityRoot> {
    return this.httpClient.get<ICityRoot>(Constants.GET_CITY_SEARCH + query);
  }

  getHistory(): Observable<IHistoryObject> {
    return this.httpClient.get<IHistoryObject>(Constants.GET_HISTORY);
  }

  getFacilitiesByCoordinates(lat: string, lag: string): Observable<IFacility> {
    return this.httpClient.get<IFacility>(Constants.GET_FACILITIES_COORDINATES + '?latitude=' + lat + '&longitude=' + lag, { headers: new HttpHeaders({ timeout: `${3000}` }) });
  }

  getRiskCalculation(facilityId: number) {
    return this.httpClient.get<IRiskCalculatorResult>(Constants.GET_RISK_CALCULATIONS + facilityId);
  }

  setToolbarTitle(value: string) {
    this.toolBarTitle.next(value);
  }

  getToolbarTitle(): Observable<string> {
    return this.toolBarTitle.asObservable();
  }

  getEvacuationCountryList(): Observable<IEvacuationAlertLevelResult> {
    return this.httpClient.get<IEvacuationAlertLevelResult>(Constants.GET_EVACUATION_COUNTRY_DATA);
  }

}
